import React, { Component, Suspense } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { applicationContextActionCreator } from '../../store/actions';

import { Card, Button } from 'react-bootstrap'
import { CodingEventTable } from '../../controls/';

import CodingEventQueueContextProvider from '../../contexts/CodingEventQueueContext';

const CodingEvents = (props) => {

    console.log("Rendering CodingEvents")
    return (
        <CodingEventQueueContextProvider>
            {props.children}
        </CodingEventQueueContextProvider>
    )
}

export default CodingEvents;

//class CodingEventsChild extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = {
//            filters: {
//                accountId: 0,
//                assignedToId: 0,
//                queueId: 0,
//                statusId: 0,
//                searchText: '',
//                searchId: 0,
//                take: 0,
//                skip: 0,
//                showCustomerQueue: false,
//                showTeamQueue: false,
//                showMyQueue: false,
//                fetchRefData: true
//            },
//        };
//        this.updateFilters = this.updateFilters.bind(this);
//        this.resetFilters = this.resetFilters.bind(this);
//    }

//    async componentDidMount() {
//    }

//    async updateFilters(filters) {
//        let savedFilters = this.props.filters.codingEventsFilters;
//        savedFilters.codingEvents = filters;
//        return this.props.updateCodingEventQueueFilters(savedFilters);
//    }

//    async resetFilters() {
//        let savedFilters = this.props.filters.codingEventsFilters;
//        savedFilters.codingEvents = this.state.filters;
//        return this.props.updateCodingEventQueueFilters(savedFilters);
//    }

//    render() {
//        return (
//            <Card>
//                <Card.Header className="d-flex align-items-center">
//                    <div className="mr-auto" >Coding Events</div>
//                    <div className="card-btn-group">
//                        <Button variant="secondary" size="sm" onClick={() => this.resetFilters()}>Clear Filters</Button>
//                    </div>
//                </Card.Header>
//                <Card.Body className="card-body-table">
//                    <CodingEventTable filters={this.props.filters.codingEventsFilters.codingEvents} updateFilters={this.updateFilters} resetFilters={this.resetFilters} />
//                </Card.Body>
//            </Card>
//        );
//    }

//}

//export default connect(state => state.applicationContext, dispatch => bindActionCreators(applicationContextActionCreator, dispatch))(CodingEvents);